var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6679 0.499581C16.4022 0.701091 16.9805 1.29484 17.1768 2.04884C17.5335 3.41539 17.5335 6.2667 17.5335 6.2667C17.5335 6.2667 17.5335 9.1179 17.1768 10.4845C16.9805 11.2386 16.4022 11.8323 15.6679 12.0339C14.3371 12.4 9.00013 12.4 9.00013 12.4C9.00013 12.4 3.66321 12.4 2.3323 12.0339C1.59795 11.8323 1.01962 11.2386 0.823354 10.4845C0.466797 9.1179 0.466797 6.2667 0.466797 6.2667C0.466797 6.2667 0.466797 3.41539 0.823354 2.04884C1.01962 1.29484 1.59795 0.701091 2.3323 0.499581C3.66321 0.133362 9.00013 0.133362 9.00013 0.133362C9.00013 0.133362 14.3371 0.133362 15.6679 0.499581ZM7.40015 3.86664V9.19997L11.6668 6.53341L7.40015 3.86664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b1652270952984f15fc6109c77fb2f15.svg";
export { ForwardRef as ReactComponent };